import cookieParser from 'cookie';
import Cookie from 'js-cookie';

import { AFFILIATE_COOKIE_NAME } from 'shared-utils';

const AFFILIATE_QUERY_PARAM = 'aff';
const AFFILIATE_COOKIE_MAX_AGE_DAYS = 30;
const AFFILIATE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * AFFILIATE_COOKIE_MAX_AGE_DAYS;
const AFFILIATE_CODE_REGEXP = /^[a-z0-9-]{1,64}$/;

export const isValidAffiliateCode = (value) =>
  typeof value === 'string' && AFFILIATE_CODE_REGEXP.test(value);

const captureAffiliateCode = (ctx) => {
  const affiliateCode = ctx.query?.[AFFILIATE_QUERY_PARAM];

  if (!isValidAffiliateCode(affiliateCode)) {
    return;
  }

  if (ctx.req) {
    const existingCookies = ctx.res.getHeader('Set-Cookie');
    const setCookieHeader = existingCookies
      ? Array.isArray(existingCookies)
        ? [...existingCookies]
        : [existingCookies]
      : [];
    setCookieHeader.push(
      cookieParser.serialize(AFFILIATE_COOKIE_NAME, affiliateCode, {
        path: '/',
        maxAge: AFFILIATE_COOKIE_MAX_AGE_SECONDS,
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'lax',
      })
    );
    ctx.res.setHeader('Set-Cookie', setCookieHeader);
  } else {
    Cookie.set(AFFILIATE_COOKIE_NAME, affiliateCode, {
      path: '/',
      expires: AFFILIATE_COOKIE_MAX_AGE_DAYS,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
    });
  }
};

export default captureAffiliateCode;
